module.exports = __webpack_public_path__ + "img/gift_es.1daba9ad.jpg";